import { render, staticRenderFns } from "./IconSlider.vue?vue&type=template&id=1777a4fd&scoped=true&"
import script from "./IconSlider.vue?vue&type=script&lang=js&"
export * from "./IconSlider.vue?vue&type=script&lang=js&"
import style0 from "./IconSlider.vue?vue&type=style&index=0&id=1777a4fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1777a4fd",
  null
  
)

export default component.exports